import React from "react";

export const Logo = props => <img src={`https://client-upload.bytehogs.com/amsh/brand/${props.mobile ? "amsh-logo" : "amsh-logo"}.png`} className={"logo " + (props.className || "")} alt="Are My Staff Happy"/>
